import { useFormContext } from '@calendly/form'
import { I18n } from '@calendly/i18n'
import { Badge, BADGE_TYPE_INFO } from '@calendly/ui/components/badge'
import { BodyText, LabelText, TitleText } from '@calendly/ui/components/typography'
import { Fragment } from 'react'

import { CustomQuestionsSection } from './custom_questions_section'
import { getAnswerTypeBadgeLabel } from './helpers'
import { lockedQuestionsListCss, headerCss, sectionCss, tabCss } from './styles'

const QuestionsTabLocked = () => {
  const { values: { inviteeQuestions } } = useFormContext()
  const undeletedQuestions = inviteeQuestions.filter(({ _destroy }) => !_destroy)

  return (
    <div className={tabCss} data-testid="questions-tab-locked">
      <header className={headerCss}>
        <TitleText level={2}>
          {I18n.t('publisher.event_type_editor_crud.booking_page.title')}
        </TitleText>
        <BodyText color="muted" size="large">
          {I18n.t('publisher.event_type_editor_crud.booking_page.subtitle')}
        </BodyText>
      </header>
      <div className={sectionCss}>
        <div className={lockedQuestionsListCss}>
          <LabelText size="large">{I18n.t('publisher.event_type_editor_crud.booking_page.name_label')}</LabelText>
          <LabelText size="large">{I18n.t('publisher.event_type_editor_crud.booking_page.email_label')}</LabelText>
          {undeletedQuestions.map(({ name, format }) => (
            <Fragment key={name || format}>
              <LabelText size="large">{name}</LabelText>
              <Badge type={BADGE_TYPE_INFO}>{getAnswerTypeBadgeLabel(format)}</Badge>
            </Fragment>
          ))}
        </div>
      </div>
    </div>
  )
}

const QuestionsTabEditable = () => (
  <div className={tabCss} data-testid="questions-tab">
    <header className={headerCss}>
      <TitleText level={2}>
        {I18n.t('publisher.event_type_editor_crud.booking_page.title')}
      </TitleText>
      <BodyText color="muted" size="large">
        {I18n.t('publisher.event_type_editor_crud.booking_page.subtitle')}
      </BodyText>
    </header>
    <div className={sectionCss}>
      <CustomQuestionsSection />
    </div>
  </div>
)

export const QuestionsTab = ({ isLocked = false }) => (
  isLocked ? <QuestionsTabLocked /> : <QuestionsTabEditable />
)
